<template>
  <div class="product-list">
    <div class="product-items" v-if="products.length > 0">
      <div 
        v-for="product in products" 
        :key="product.id"
        class="product-item"
      >
        <div class="product-image">
          <img :src="imgserver + product.coverImage" :alt="product.title" />
        </div>
        <div class="product-info">
          <h3 class="product-title">{{ product.title }}</h3>
          <p class="product-date">{{ formatDate(product.updatedAt) }}</p>
          <p class="product-description">{{ product.subtitle }}</p>
          <button class="view-details-btn" @click="viewProductDetails(product)">
            查看详细信息
          </button>
        </div>
      </div>
    </div>
    
    <!-- 空状态 -->
    <div v-else-if="products.length === 0" class="empty-state">
      <div class="empty-icon">📦</div>
      <h3>暂无产品信息</h3>
      <p>当前分类下没有找到相关产品</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductList',
  props: {
    products: {
      type: Array,
      default: () => []
    }
  },
  updated() {
    console.log(this.products.length);
  },
  methods: {
    viewProductDetails(product) {
      this.$emit('view-details', product);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN');
    }
  }
}
</script>

<style lang="scss" scoped>
// 产品列表模式
.product-list {
  width: 100%;
  
  .product-items {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .product-item {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    display: flex;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }
    
    .product-image {
      width: 180px;
      height: 180px;
      overflow: hidden;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      
      img {
        width: 150px;
        height: 150px;
        object-fit: cover;
        transition: transform 0.3s ease;
      }
    }
    
    .product-info {
      flex: 1;
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      
      .product-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        margin: 0 0 10px 0;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      
      .product-date {
        font-size: 14px;
        color: #666;
        margin: 0 0 15px 0;
      }
      
      .product-description {
        font-size: 14px;
        color: #666;
        line-height: 1.6;
        margin: 0 0 20px 0;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        flex: 1;
      }
      
      .view-details-btn {
        background: #5e7c85;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 5px;
        cursor: pointer;
        font-size: 14px;
        transition: background 0.3s ease;
        align-self: flex-end;
        
        &:hover {
          background: #4a6b73;
        }
      }
    }
  }
  
  .empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #666;
    
    .empty-icon {
      font-size: 48px;
      margin-bottom: 20px;
    }
    
    h3 {
      font-size: 20px;
      color: #333;
      margin: 0 0 10px 0;
    }
    
    p {
      font-size: 16px;
      margin: 0 0 20px 0;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .product-list {
    .product-item {
      flex-direction: column;
      
      .product-image {
        width: 100%;
        height: 200px;
      }
    }
  }
}
</style>
